<template>
  <div class="py-4 container-fluid">
   
    <div class="row">

      
      <div v-if="showMapa" class="col-12 pb-0 card-header mb-0">
        <div class="google-map" ref="googleMap"></div>
        <template v-if="Boolean(this.google) && Boolean(this.map)">
          <slot
            :google="google"
            :map="map"
          />
        </template>
      </div>
      <div class="col-12">
        <pedidos-localizacao-table :pedidos="pedidos" :filtro="filtro" :searchCall="searchCall" :doRemovePedido="doRemovePedido" :map="map" />
        <loading  v-if="isLoading" />

          <div class="dataTable-bottom">
            <div class="dataTable-info">
              Mostrando {{ current_page * per_page + 1 }} até 
              <select v-model.number="per_page" @change="getPaginas(0)">
                <option v-for="option in per_page_options" :key="option" :value="option">
                  {{ option === -1 ? 'Todos' : option }}
                </option>
              </select> de 
              {{ total_count }} {{ local_page }}
            </div>



            <nav class="dataTable-pagination">
              <ul class="dataTable-pagination-list">
                <li @click="getPaginas(Math.max((current_page - 1) * per_page, 0))" 
                    class="pager" 
                    :class="{ disabled: current_page === 0 }">
                  <a href="#">‹</a>
                </li>

                <li v-for="page in total_pages" :key="page" 
                    @click="getPaginas((page - 1) * per_page)" 
                    :class="{ active: current_page === (page - 1) }">
                  <a href="#">{{ page }}</a>
                </li>

                <li @click="getPaginas(Math.min((current_page + 1) * per_page, (total_pages - 1) * per_page))" 
                    class="pager"
                    :class="{ disabled: current_page === total_pages - 1 }">
                  <a href="#">›</a>
                </li>
              </ul>
            </nav>
          </div>

      </div>
    </div>
  </div>
</template>

<script>

import GoogleMapsApiLoader from 'google-maps-api-loader'

import { defineComponent, ref } from 'vue';


import PedidosLocalizacaoTable from "./components/PedidosLocalizacaoTable.vue";
import ArgonButton from "@/components/ArgonButton.vue";

import Loading from "./components/Loading.vue";

import fintailapi from "../api";

const { v4: uuidv4 } = require('uuid');

import { useToast } from "vue-toastification";

export default defineComponent({
  name: "tables",
  components: {
    PedidosLocalizacaoTable,
    ArgonButton,
    Loading
  },
  data() {
    return {
      map: null,
      google: null,
      filtro:null,
      data_sincroniza: {data_inicial:"", data_final:""},
      sincronizar: { show:false, progress:0 },
      modo : "view",
      pedidos: [],
      current_page:0,
      offset:0,
      current_offset:0,
      total_count: 0,
      total_pages: 0,
      isLoading:true,
      showMapa:true,
      per_page: 10,
      per_page_options: [10, 30, 50, 100, -1], // -1 = todos
      toast : useToast(),
      local_page : "Pedidos",
    };
  },
  async mounted() {
    
    if(this.modo=="view"){
      const googleMapApi = await GoogleMapsApiLoader({
        apiKey: process.env.VUE_APP_MAPS_APIKEY
      })
      this.google = googleMapApi
      this.initializeMap()
    }

  },
  methods: {

    hideMapa() {
      this.showMapa = !this.showMapa
    },
    
    initializeMap() {

      const mapContainer = this.$refs.googleMap

      this.map = new this.google.maps.Map(
        mapContainer, {   
            clickableIcons: false,
            streetViewControl: false,
            panControlOptions: false,
            gestureHandling: "cooperative",
            mapTypeControl: true,
            styles: [
                        {
                            "featureType": "administrative",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "poi",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "on" }]
                        },
                        {
                            "featureType": "transit",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "off" }]
                        }
                    ],
                
            zoomControlOptions: {
              style: "SMALL"
            },
            zoom: 13,
            minZoom: 8,
            maxZoom: 20,
            center: { lat: -22.2941067, lng: -48.5642125 }
        }
      )



/*
      var marker = new this.google.maps.Marker({
        position: { lat: -22.2941067, lng: -48.5642125 },
        map:  this.map,
        title: "Centro",
        icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png' // Ícone do marcador
      });
*/

      this.getPedidos(0)

    },  
    getPaginas(offset) {

        if (this.total_count > 0 && (offset < 0 || offset >= this.total_count)) return; // Impede valores inválidos
        
        this.current_offset = offset;

        this.getPedidos(offset);       

    },

    getPedidos(offset) {

        this.isLoading = true
        
        fintailapi
        .get(`/pedidos?offset=${offset}&limit=${this.per_page}`)
        .then((response) => {

          this.isLoading=false
          this.current_page = offset;

          this.pedidos = response.data.pedidos;

          this.current_page = offset / this.per_page; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count / this.per_page);


          const POINT_MARKER_ICON_CONFIG = {
            path: "M 0, 0 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0",
            strokeOpacity: 0.7,
            strokeWeight: 4,
            strokeColor: "#FFAD00",
            fillColor: "rgb(255,255,255)",
            fillOpacity: 0.7,
            scale: 1
          };

          const { Marker } = this.google.maps;

        const markers = [];

         for(let  pedido of this.pedidos){

            const local = {
                id: pedido.numero_pedido,
                id_pedido: pedido.id_pedido,
                position: { lat: parseFloat(pedido.latitude), lng:  parseFloat(pedido.longitude) }
            };
            
           const marker =  new Marker({
              position: local.position,
              draggable: false,
              marker: local,
              map: this.map,
              icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
            });



            pedido.marker = marker

            marker._idPedido = pedido.numero_pedido;


            marker.addListener('click', () => {

              

              markers.forEach(m => {
                m.setIcon('https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png');
                m.setDraggable(false);
              });

              // Ativar o clicado
              if(this.filtro != marker._idPedido){

                  this.searchCall("numero_pedido", marker._idPedido)
                  this.filtro = marker._idPedido

                  marker.setIcon('https://maps.google.com/mapfiles/ms/icons/green-dot.png');
                  marker.setDraggable(true);

              }else{

                  this.getAll();
                  this.filtro = ""
                  
              }




            });


            marker.addListener('dragend', () => {
              
              const newPosition = marker.getPosition();
              console.log('Nova posição:', newPosition.lat(), newPosition.lng());

              
              fintailapi
              .put(`/pedidos/${local.id_pedido}`,{
                    latitude: newPosition.lat(),
                    longitude: newPosition.lng()
                  })
              .then((response) => {

              })
              .catch((error) => {
                this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
              })

            });

            markers.push(marker);

         }  
         
         const newLocation = { lat: parseFloat(this.pedidos[0].latitude), lng: parseFloat(this.pedidos[0].longitude)  }; // Rio de Janeiro
         this.map.setCenter(newLocation); // Define o novo centro



        })
        .catch((error) => {

          //this.isOpenRef = true;

        })

    },
    doRemovePedido(pedido) {

      //this.sincronizar.show = true
      //this.sincronizar.progress = 20


      fintailapi
      .delete(`/pedidos/${pedido.id_pedido}`)
      .then((response) => {

          this.sincronizar.progress = 100
          this.sincronizar.show = false

          this.getPedidos(0)

      })
      .catch((error) => {
        this.sincronizar.show = false
        this.sincronizar.error = error.message
      })


    },
    searchCall(campo, termo) {

      fintailapi
        .get(`/pedidos/pesquisar/campo?term=${termo}&field=${campo}`)
        .then((response) => {
          this.current_offset = 0;
          this.current_page = 0 / this.per_page; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count / this.per_page);
          this.pedidos = response.data.rows;
        })
        .catch((error) => {
          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
        })

    },
    getAll() {

      
        fintailapi
        .get(`/pedidos?offset=0&limit=10`)
        .then((response) => {

          this.isLoading=false
          this.current_page = 0;

          this.pedidos = response.data.pedidos;
          //this.total_pages = response.data.count / 10
        })
        .catch((error) => {
          console.log(error)
          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
        })

    },
   },
   gotoMapa(campo) {


   },  
   created() {

      this.modo = this.$route.params.id||'view';

      console.log(this.modo)

    },

});


</script>
